import{
    apiRequest,
    dependentDetail,
    dependentUpdate,
} from "../../../../../services/adapters/master/dependentService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", dependentDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", dependentUpdate, {
            body: query
        }, true)
    }

}

export default UpdateRepository